export default {
  setMediaModalState({ commit }, state) {
    commit('SET_MEDIA_MODAL_STATE', state);
  },
  setDatePickerShortcut({ commit }, value) {
    commit('SET_DATE_PICKER_SHORTCUT', value);
  },
  setDatePickerRange({ commit }, value) {
    commit('SET_DATE_PICKER_RANGE', value);
  },
  setDatePickerResolution({ commit }, value) {
    commit('SET_DATE_PICKER_RESOLUTION', value);
  },
  clearDatePickerResolution({ commit }) {
    commit('CLEAR_DATE_PICKER_RESOLUTION');
  },
  satNumbersFilter({ commit }, numbers) {
    commit('SET_NUMBERS_FILTER', numbers);
  },
  draggedOverKey({ commit }, key) {
    commit('SET_DRAGGED_OVER_KEY', key);
  },
  setStepperDataStore({ commit }, data) {
    commit('SET_STEPPER_DATA_STORE', data);
  },
  clearStepperDataStore({ commit }) {
    commit('CLEAR_STEPPER_DATA_STORE');
  },
};
